import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListRoutes from './Listroutes';
import DefaultLayout from './DefaultLayout';
import AdminLayout from './AdminLayout';

export const useRoutes = (isAuth, roles) => {
    const checkRoles = (userRoles, routeRoles) => {
        if (!routeRoles) return true;
        if (routeRoles && !userRoles) return false;
        for (let i = 0; i < routeRoles.length; i += 1) {
            if (userRoles.indexOf(routeRoles[i]) !== -1) return true;
        }
        return false;
    };
    if (isAuth) {
        return (
            <React.Suspense>
                <Routes>
                    {ListRoutes.map((route) => {
                        if (
                            route.private &&
                            (!route.roles ||
                                !roles ||
                                checkRoles(roles, route.roles))
                        ) {
                            return (
                                <Route
                                    element={
                                        <AdminLayout element={route.element} />
                                    }
                                    path={route.path}
                                    key={route.path}
                                />
                            );
                        } else if (!route.private && !route.layoutEmpty) {
                            return (
                                <Route
                                    element={
                                        <DefaultLayout
                                            element={route.element}
                                        />
                                    }
                                    path={route.path}
                                    key={route.path}
                                />
                            );
                        }
                    })}
                </Routes>
            </React.Suspense>
        );
    }
    return (
        <React.Suspense>
            <Routes>
                {ListRoutes.map((route) => {
                    if (!route.private && !route.layoutEmpty) {
                        return (
                            <Route
                                element={
                                    <DefaultLayout element={route.element} />
                                }
                                path={route.path}
                                key={route.path}
                            />
                        );
                    } else if (route.layoutEmpty) {
                        return (
                            <Route
                                element={route.element}
                                path={route.path}
                                key={route.path}
                            />
                        );
                    }
                })}
            </Routes>
        </React.Suspense>
    );
};
